<template>
  <div id="settingsServices">
    <div class="container">

      <div class="page-title" v-if="ready && !companyId">
        {{ $t("settings.online_ordering") }}
      </div>

      <div class="tabs" v-if="(ready && companyId) || true">
        <div class="tab" :class="{ active: activeTab === 1 }" @click="selectTab(1)">{{ $t("settings.online_ordering") }}
        </div>
        <div v-if="branchModule.onlineOrdering" class="tab"
          :class="{ active: activeTab === 2, disabled: !config.takeout.activated }" @click="selectTab(2)">
          {{ $t("deliveryMethod.takeout") }}
        </div>
        <div v-if="branchModule.onlineOrdering" class="tab"
          :class="{ active: activeTab === 3, disabled: !config.delivery.activated }" @click="selectTab(3)">
          {{ $t("deliveryMethod.delivery") }}
        </div>
        <div v-if="branchModule.onSiteOrdering" class="tab"
          :class="{ active: activeTab === 4, disabled: !config.inPlace.activated }" @click="selectTab(4)">
          {{ $t("deliveryMethod.in_place") }}
        </div>
        <div v-if="branchModule.catering" class="tab"
          :class="{ active: activeTab === 5, disabled: !config.catering.activated }" @click="selectTab(5)">
          {{ $t("deliveryMethod.catering") }}
        </div>
        <div v-if="branchModule.onSiteOrdering" class="tab"
          :class="{ active: activeTab === 6, disabled: !config.hotel.activated }" @click="selectTab(6)">
          {{ $t("deliveryMethod.hotel") }}
        </div>
      </div>

      <SettingsDefault v-if="ready" v-show="activeTab === 1" ref="settingsDefault" :parentValidate="$validate"
        class="content" v-on:save="save" :config="config" :permissions="permissions" :branch="branch"
        @changeTutorialImage="changeTutorialImage($event)" @addTutorialPage="addTutorialPage"
        @removeTutorialPage="removeTutorialPage($event)" @changeMenuDisplay="changeMenuDisplay"
        @changeFromOrderMethod="changeFromOrderMethod" :rootFields="rootFields" :branchModule="branchModule"
        :posActivated="posActivated" />

      <SettingsTakeout v-if="ready && branchModule.onlineOrdering" v-show="activeTab === 2" :parentValidate="$validate"
        class="content" v-on:save="save" :parentConfig="parentConfig" :config="config" :permissions="permissions"
        :currency-symbol="currencySymbol" />

      <SettingsDelivery v-if="ready && branchModule.onlineOrdering" v-show="activeTab === 3" :parentValidate="$validate"
        class="content" v-on:save="save" :parentConfig="parentConfig" :config="config" :permissions="permissions"
        :isActive="activeTab === 3" :currency-symbol="currencySymbol" />

      <SettingsInplace v-if="ready && branchModule.onSiteOrdering" v-show="activeTab === 4" :parentValidate="$validate"
        class="content" v-on:save="save" :parentConfig="parentConfig" :config="config" :permissions="permissions"
        :currency-symbol="currencySymbol" />

      <SettingsCatering v-if="ready && branchModule.catering" v-show="activeTab === 5" :parentValidate="$validate"
        class="content" v-on:save="save" :parentConfig="parentConfig" :config="config" :permissions="permissions"
        :currency-symbol="currencySymbol" />

      <SettingsHotel v-if="ready && branchModule.onSiteOrdering" v-show="activeTab === 6" :parentValidate="$validate"
        class="content" v-on:save="save" :parentConfig="parentConfig" :config="config" :permissions="permissions"
        :currency-symbol="currencySymbol" />

    </div>
  </div>
</template>

<script>
import SettingsDefault from "./services/SettingsDefault.vue";
import SettingsTakeout from "./services/SettingsTakeout.vue";
import SettingsDelivery from "./services/SettingsDelivery.vue";
import SettingsInplace from "./services/SettingsInplace.vue";
import SettingsCatering from "./services/SettingsCatering.vue";
import SettingsHotel from "./services/SettingsHotel.vue";
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  name: "SettingsServices",

  components: {
    SettingsDefault,
    SettingsTakeout,
    SettingsDelivery,
    SettingsInplace,
    SettingsCatering,
    SettingsHotel
  },

  data() {
    return {
      activeTab: 1,
      parentConfig: {},
      config: {},
      rootFields: {},
      permissions: {},
      currencySymbol: '$',
      branchModule: {
        onlineOrdering: false,
        onSiteOrdering: false,
        catering: false,
      },
      branchId: null,
      branch: null,
      company: null,
      companyId: null,
      methods: ["delivery", "takeout", "inPlace", "catering", "hotel"],
      posActivated: null,
      ready: false
    }
  },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "settings.services";
    this.$store.state.pageIcon = "";
    this.branchId = this.$route.query.branch;
    this.companyId = this.$route.query.company;

    if (this.branchId) {
      if (this.companyId) {
        this.currencySymbol = await this.$store.getters.getContextCurrencySymbol;
        await this.getCompanyConfig();
      } else {
        await this.getBranchConfig();
      }
      let activatedModule = await this.$store.getters.getContextBranchActivatedModule;
      Object.assign(this.branchModule, activatedModule);
      this.ready = true;
    } else {
      this.$router.push("/");
    }

    if (!this.$store.getters.loggedUserHasModifyPermission) {
      window.lockFields();
    }
  },

  validate: [{
    "config.takeout.onEnterMessage.message.fr": { maxLength: 200 },
    "config.takeout.onEnterMessage.message.en": { maxLength: 200 },
    "config.default.general.tipOptions": {
      required: false,
      regex: /^[0-9]+(,[0-9]+)*$/
    },
    "config.default.defaultTipAmount": {
      number: true
    },
    "config.takeout.hours.monday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.monday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.tuesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.tuesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.wednesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.wednesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.thursday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.thursday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.friday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.friday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.saturday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.saturday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.takeout.hours.sunday.hours": {
      required: true, array: true,
      condition: function () { return this.config.takeout.hours.sunday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.onEnterMessage.message.fr": { maxLength: 200 },
    "config.delivery.onEnterMessage.message.en": { maxLength: 200 },
    "config.delivery.hours.monday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.monday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.tuesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.tuesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.wednesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.wednesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.thursday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.thursday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.friday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.friday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.saturday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.saturday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.delivery.hours.sunday.hours": {
      required: true, array: true,
      condition: function () { return this.config.delivery.hours.sunday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.onEnterMessage.message.fr": { maxLength: 200 },
    "config.inPlace.onEnterMessage.message.en": { maxLength: 200 },
    "config.inPlace.hours.monday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.monday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.tuesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.tuesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.wednesday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.wednesday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.thursday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.thursday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.friday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.friday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.saturday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.saturday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    },
    "config.inPlace.hours.sunday.hours": {
      required: true, array: true,
      condition: function () { return this.config.inPlace.hours.sunday.open },
      elements: { from: { required: true, hour: true }, to: { required: true, hour: true } }
    }
  }],

  methods: {
    ...mapActions([
      "getBranchParentConfiguration", "getBranch", "saveBranch",
      "getCompanyParentConfiguration", "getCompany", "saveCompany"
    ]),

    selectTab(index) {
      this.activeTab = index;

      if (!this.$store.getters.loggedUserHasModifyPermission) {
        window.lockFields();
      }
    },

    async getBranchConfig() {
      let config = await this.getBranch({ branchId: this.branchId, fallback: true });
      this.branch = config;
      this.config = config.onlineOrdering;
      let parentConfig = await this.getBranchParentConfiguration({ branchId: this.branchId });
      this.parentConfig = parentConfig.onlineOrdering;
      this.initializeConfiguration();
    },

    async getCompanyConfig() {
      let config = await this.getCompany({ branchId: this.branchId, companyId: this.companyId, fallback: true, augment: 'backend' });
      this.$store.state.contextCompany = config;
      this.company = config;
      this.config = config.onlineOrdering;
      let parentConfig = await this.getCompanyParentConfiguration({ branchId: this.branchId, companyId: this.companyId });
      this.parentConfig = parentConfig.onlineOrdering;
      this.rootFields = {
        emergencyCloseExternalOffline: config.emergencyCloseExternalOffline,
        emergencyCloseManually: config.emergencyCloseManually,
        emergencyCloseManuallyMessage: {
          fr: config.emergencyCloseManuallyMessage ? config.emergencyCloseManuallyMessage.fr : null,
          en: config.emergencyCloseManuallyMessage ? config.emergencyCloseManuallyMessage.en : null
        },
        saleEmailMessage: {
          fr: config.saleEmailMessage ? config.saleEmailMessage.fr : null,
          en: config.saleEmailMessage ? config.saleEmailMessage.en : null,
        },
        notifyIfPosIsNotReachable: config.notifyIfPosIsNotReachable,
        bypassPosMode: config.bypassPosMode,
        bypassPosOptions: this._parseAsObject(config.bypassPosOptions),
        holdAndFire: config.holdAndFire,
        holdAndFireOptions: this._parseAsObject(config.holdAndFireOptions),
        stockActivated: config.stockActivated
      };
      this.permissions = {
        tipsActivated: !(config.paymentProcessors.length === 0 || config.paymentProcessors.indexOf('none') !== -1), /* If online payment is activated */
        polygonZoning: this.$store.getters.loggedUserHasBranchAdmin, /* TODO cleanup */
      };
      this.posActivated = config.activePOS ? !!config.activePOS.length : false;
      if (this.config.delivery && !this.config.delivery.geocodeService) {
        this.config.delivery.geocodeService = "here";
      }

      this.initializeConfiguration();
    },

    initializeConfiguration() {
      for (let method of this.methods) {
        this._configureMethod(method);
      }
      if (this.branch && !this.branch.tutorial) {
        this.branch.tutorial = {
          activated: false,
          backgroundImage: null,
          logoImage: null,
          pages: []
        }
      }
      if (this.branch && !this.branch.homePage.title) {
        this.branch.homePage.title = { fr: "", en: "" };
      }
      if (this.branch && !this.branch.homePage.subtitle) {
        this.branch.homePage.subtitle = { fr: "", en: "" };
      }
    },

    addTutorialPage() {
      this.branch.tutorial.pages.push({
        image: { url: "" },
        title: { fr: "", en: "" },
        description: { fr: "", en: "" }
      });
      this.$refs.settingsDefault.$forceUpdate();
    },

    removeTutorialPage(pageIndex) {
      this.branch.tutorial.pages.splice(pageIndex, 1);
      this.$refs.settingsDefault.$forceUpdate();
    },

    changeTutorialImage(data) {
      this.branch.tutorial.pages[data.pageIndex].image = data.image;
      this.$refs.settingsDefault.$forceUpdate();
    },

    changeMenuDisplay(event) {
      this.company.menuDisplay.activated = event.target.value === "true";
      this.$refs.settingsDefault.$forceUpdate();
    },

    changeFromOrderMethod(event) {
      this.company.menuDisplay.fromOrderMethod = event.target.value;
    },

    async save() {
      if (!this.$validate.valid(0)) {
        toast(this.$t("error.invalid_fields"), "error");
        return;
      }

      for (let zone of this.config.delivery.zones) {
        if (zone.type === "polygon") {
          let isValid = isValidJSON(zone.polygons);
          if (!isValid) {
            let index = this.config.delivery.zones.indexOf(zone) + 1;
            showAffirmation(this.$t("settings.invalid_zone"), this.$t("settings.invalid_zone_description").replace("{INDEX}", index));
            return;
          }
          zone.polygons = (zone.polygons && typeof zone.polygons == "string") ? JSON.parse(zone.polygons) : zone.polygons;
        }
      }

      this.$store.commit("showSpinner", true);
      for (let method of this.methods) {
        this._formatBeforeSave(method);
      }
      if (this.branchId) {
        if (this.companyId) {
          let response = await this.saveCompany({
            branchId: this.branchId,
            companyId: this.companyId,
            data: Object.assign({ onlineOrdering: this.config, menuDisplay: this.company.menuDisplay }, this.rootFields)
          });
          if (response) {
            toast(this.$t("company.success"), "success");
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        } else {
          let tutorial = this._copy(this.branch.tutorial);
          let homePage = this._copy(this.branch.homePage);
          delete tutorial.backgroundImage;
          delete tutorial.logoImage;
          delete homePage.backgroundImage;
          delete homePage.backgroundVideo;
          if (tutorial) {
            this._formatImagesBeforeSave(tutorial);
          }
          let response = await this.saveBranch({
            branchId: this.branchId,
            data: {
              autocompleteOnOrderType: this.branch.autocompleteOnOrderType,
              autocompleteOnPayment: this.branch.autocompleteOnPayment,
              onlineOrdering: this.config,
              emailValidationRequired: this.branch.emailValidationRequired,
              homePage: !!homePage ? homePage : undefined,
              tutorial: !!tutorial ? tutorial : undefined
            }
          });
          if (response) {
            toast(this.$t("branch.success"), "success");
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        }
      }

      for (let zone of this.config.delivery.zones) {
        if (typeof zone.polygons !== "string") {
          zone.polygons = JSON.stringify(zone.polygons);
        }
      }

      this.$store.commit("showSpinner", false);
    },

    _configureMethod(method) {
      if (!this.config[method].general) {
        this.config[method].general = this._copy(this.parentConfig[method].general);
      }
      if (!this.config[method].inAdvance) {
        this.config[method].inAdvance = this._copy(this.parentConfig[method].inAdvance);
      }
      if (!this.config[method].notifications) {
        this.config[method].notifications = this._copy(this.parentConfig[method].notifications);
      }
      if (!this.config[method].onEnterMessage) {
        this.config[method].onEnterMessage = this._copy(this.parentConfig[method].onEnterMessage);
      }
      Vue.set(this.config[method], "editOpenHours", !!((this.config[method] || {}).hours));
      Vue.set(this.config[method], "hours", (this.config[method] || {}).hours);
    },

    _formatBeforeSave(method) {
      this.config.default.geocodeService = this.config.default.geocode.geocodeService;

      if (!this.config[method].hours) {
        Vue.set(this.config[method], "hours", null);
      }
      for (let i = 0; i < this.config.delivery.zones.length; i++) {
        let zone = this.config.delivery.zones[i];
        let zipCodes = zone.zipCodes.toString();
        zone.zipCodes = zipCodes.split(",");
      }

      if (this.company && !this.company.smsActivated) {
        delete this.config.default.notifications.activateCustomerNotificationsBySms;
        delete this.config.takeout.notifications.onSale.sms;
        delete this.config.delivery.notifications.onSale.sms;
        delete this.config.inPlace.notifications.onSale.sms;
        delete this.config.catering.notifications.onSale.sms;
      }
    },

    _formatImagesBeforeSave(tutorial) {
      if (tutorial.pages) {
        for (let page of tutorial.pages) {
          page.image = getImageData(page.image);
        }
      }
    },

    _copy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    _parseAsObject(t) {
      return t && typeof t === 'object' && t.length === undefined ? t : {}
    }
  }
}
</script>

<style lang="scss" scoped>
#settingsServices {
  display: flex;

  &>.container {
    display: flex;
    flex-direction: column;
  }
}

.content {
  padding-top: 40px;
}
</style>